<template>
  <v-card>
    <v-card-title primary-title>
      <h6 class="title">{{ $t('history') }}</h6>
    </v-card-title>
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="items"
        :pagination.sync="pagination"
        class="elevation-1"
      >
        <template slot="items" slot-scope="props">
          <!-- <td>{{ props.item.uploadTime | moment("DD/MM/YYYY HH:mm:ss") }}</td> -->
          <td>{{ $d(new Date(props.item.uploadTime), 'table') }}</td>
          <td>{{ props.item.application }}</td>
          <td>
            <!-- <a href @click.prevent="downloadFile(props.item)">{{ props.item.fileName }}</a> -->
            {{ props.item.fileName }}
          </td>
          <td>{{ props.item.fileType }}</td>
          <td>{{ beaufityFilesize(props.item.fileSize) }}</td>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import * as filesize from "filesize";
import { mapState } from "vuex";
import * as filesActionTypes from "../store/modules/files/action-types";
export default {
  data: () => ({
    pagination: {
      rowsPerPage: 10,
      sortBy: "uploadTime",
      descending: true
    }
  }),
  mounted() {
    this.$store.dispatch(filesActionTypes.GET_FILES_ASYNC);
  },
  methods: {
    downloadFile(file) {
      this.$store.dispatch(filesActionTypes.DOWNLOAD_FILE_ASYNC, file);
    },
    beaufityFilesize(size) {
      let exponent = 0
      if (size >= 1024 && size < (1024*1024)) {
        exponent = 1
      } else if (size >= (1024*1024)) {
        exponent = 2
      }

      return filesize(size, {
        exponent: exponent,
        round: size < (1024 * 1024) ? 0 : 2
      });
    }
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("datetime"),
          sortable: true,
          value: "uploadTime"
        },
        {
          text: this.$t("application"),
          sortable: true,
          value: "application"
        },
        {
          text: this.$t("filename"),
          value: "fileName"
        },
        {
          text: this.$t("filetype"),
          value: "fileType"
        },
        {
          text: this.$t("filesize"),
          sortable: true,
          value: "fileSize"
        }
      ];
    },
    ...mapState({
      items: state => state.files.data
    })
  }
};
</script>

<style>
</style>
